<template>
  <Start>
    <div class="card">
      <div class="card-header">
        <span class="card-header-title">Set new password</span>
      </div>

      <div class="card-content">
        <form @submit.stop.prevent="send()">
          <div>
            <BForm
              :elements="form"
              @valid="form.valid = $event"
              @submit="send()"
            ></BForm>
          </div>

          <section class="footer-container">
            <button
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading || !form.valid"
              class="button is-primary"
              type="submit"
            >
              Set new password
            </button>
          </section>
        </form>

        <section class="buttons-section">
          <router-link
            @click.stop.prevent=""
            type="button"
            class="simple-button"
            to="/signin"
          >
            Go to sign in
          </router-link>
        </section>
      </div>
    </div>
  </Start>
</template>

<script>
import Start from "@/components/singles/Start.vue";
import BForm from "@/components/singles/BForm/component.vue";
import { reroute } from "@/utils/auth";

export default {
  components: {
    BForm,
    Start,
  },
  props: { value: Boolean },
  data() {
    return {
      isLoading: false,

      form: {
        valid: false,
        inputs: [
          {
            focus: true,
            icon: "mdi-lock",
            name: "code",
            placeholder: "Code",
            type: "text",
            validation: "min:5|max:5",
            value: "",
          },
          {
            icon: "mdi-lock",
            label: null,
            name: "password",
            placeholder: "New password",
            type: "password",
            validation: "min:8|confirmed:confirmation",
            value: "",
          },
        ],
      },
    };
  },
  computed: {},
  async mounted() {},
  methods: {
    async send() {
      console.log("triggered");
      if (!this.form.valid) {
        return;
      }

      this.isLoading = true;

      try {
        await this.$helpers.postApi(
          "user/resetpassword",
          {
            newPassword: this.form.inputs[1].value.trim(),
            challange: this.form.inputs[0].value.trim(),
            autoChallange: this.$route.params.challange,
          },
          { skipAuth: true, fullDataObject: true }
        );

        this.$helpers.notify(
          "Success",
          "New password has been set.",
          "success"
        );

        reroute(true);
      } catch ({ response }) {
        if (response.status === 403) {
          this.$helpers.notify(
            "Invalid",
            "The code or password reset link is invalid.",
            "warning",
            -1
          );
        } else this.$helpers.notify("Error", "Unknown error.", "danger", -1);
      }

      this.isLoading = false;
    },
  },
};
</script>
